var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wxScan"},[_c('img',{attrs:{"src":`/activity/api.php?m=public&subm=qrcode&url=${encodeURIComponent(_vm.URL)}`,"alt":""}}),_c('div',{staticClass:"note"},[_vm._v("请在微信中打开")]),(_vm.isClient)?_c('div',{staticClass:"btn",on:{"click":_vm.btnClose}},[_vm._v("确定")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }